import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/',
            redirect:'/login',
        },
        {
            path: '/login',
            name: 'Login',
            hidden: true,
            component: require('@views/Login.vue').default
        },
        {
            path: '/home',
            name: '订单',
            component: require('@views/Home.vue').default,
            children: [
                {
                    path: '/home/orderlist',
                    name: '订单列表',
                    component: require('@views/order/Orderlist.vue').default,
                },
                {
                    path: '/home/orderdetail',
                    name: '订单详情',
                    component: require('@views/order/Orderdetail.vue').default
                },
                {
                    path: '/home/orderdetail_',
                    name: '订单详情_',
                    component: require('@views/order/Orderdetail_.vue').default
                },
                {
                    path: '/home/productlist',
                    name: '商品列表',
                    component: require('@views/order/productlist.vue').default
                },
                {
                    path: '/home/chart',
                    name: '图表数据',
                    component: require('@views/order/chart.vue').default
                },
                {
                    path: '/home/search',
                    name: '搜索',
                    component: require('@views/order/search.vue').default
                },
                {
                    path: '/home/search_',
                    name: '搜索_',
                    component: require('@views/order/search_.vue').default
                },
                {
                    path: '/home/newSearch',
                    name: '新搜索',
                    component: require('@views/order/newSearch.vue').default
                },
                {
                    path: '/home/trace',
                    name: '追踪订单',
                    component: require('@views/order/trace.vue').default
                },
                {
                    path: '/home/log',
                    name: '操作记录',
                    component: require('@views/order/log.vue').default
                },
                {
                    path: '/home/TimeScreen',
                    name: '操作记录1',
                    component: require('@views/order/TimeScreen.vue').default
                },
                {
                    path: '/home/SKU',
                    name: 'SKU',
                    component: require('@views/order/SKU.vue').default
                },
                {
                    path: '/home/Domain',
                    name: 'DOMAIN',
                    component: require('@views/order/Domain.vue').default
                }
            ]
        }
    ]
})
